import React, { useRef } from "react";
import { Dialog } from "@headlessui/react";

type ProductSummary = { plu?: string; name?: string; lot_number?: string };

type Props = {
  message: string;
  onConfirm: () => void;
  setOpen: (state: { childComponent: React.ReactNode; open: boolean }) => void;
  variant?: "default" | "skid";
  productionRunProduct?: ProductSummary;
  packagingProduct?: ProductSummary;
};

export default function PrintConfirmationModal(props: Props) {
  const {
    message,
    onConfirm,
    setOpen,
    variant = "default",
    productionRunProduct,
    packagingProduct,
  } = props;
  const confirmButtonRef = useRef(null);

  const handleConfirm = () => {
    setOpen({ childComponent: null, open: false });
    onConfirm();
  };

  const content = (
    <>
      <div className="mt-3 text-center sm:mt-5">
        <Dialog.Title
          as="h3"
          className="text-base font-normal leading-6 text-gray-800 family-didact"
        >
          Confirm print
        </Dialog.Title>
        <div className="mt-3 space-y-2 text-left">
          <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 family-didact">
              Production Run Product
            </p>
            <p className="text-sm text-gray-800 family-didact">
              {productionRunProduct?.plu || "—"} -{" "}
              {productionRunProduct?.name || "—"}
            </p>
            <p className="text-sm font-bold text-gray-900 family-didact">
              Lot: {productionRunProduct?.lot_number || "—"}
            </p>
          </div>
          <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 family-didact">
              Packaging Product
            </p>
            <p className="text-sm text-gray-800 family-didact">
              {packagingProduct?.plu || "—"} - {packagingProduct?.name || "—"}
            </p>
          </div>
        </div>
        <div className="mt-2">
          <p className="text-sm text-gray-500 family-didact">{message}</p>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center sm:grid sm:grid-flow-row-dense sm:grid-cols-2 gap-3">
        <div className="col-span-1 text-right">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
            onClick={() => setOpen({ childComponent: null, open: false })}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-1">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-light family-didact text-white shadow-sm hover:bg-green-500 col-span-1 sm:mt-0"
            onClick={handleConfirm}
            ref={confirmButtonRef}
          >
            Print
          </button>
        </div>
      </div>
    </>
  );

  return (
    <div>
      {variant === "skid" ? (
        <div className="bg-gray-100 rounded-lg p-4">{content}</div>
      ) : (
        content
      )}
    </div>
  );
}
